import { createFileRoute } from '@tanstack/react-router'

import { GroupForm } from '@/components/retail/group-form'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/groups/new',
)({
    component: NewGroupPage,
})

function NewGroupPage() {
    const { hasPermission } = useAuth()
    return <GroupForm canWrite={hasPermission('shop_catalog.write')} />
}
